import { isSoftDelted } from '../../src/utils/sync'
import type { Form_IForm } from '../Form/Form.types'
import { IDB_rowRead, IDB_rowsReadAll, IDB_rowsWrite, IDB_rowWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'

export async function IDB_formRead(id: number) {
    const form = await IDB_rowRead<Form_IForm>(IDB_globalDb, 'forms', id)
    return form != null && !isSoftDelted(form) ? form : undefined
}

// We never want to hard delete the forms as the report upload depends on it
export async function IDB_formsDeleteSoft(ids: number[]) {
    let forms = await IDB_rowsReadAll<Form_IForm>(IDB_globalDb, 'forms')
    forms = forms
        .filter((form) => ids.includes(form.id))
        .map((form) => ({
            ...form,
            meta: {
                ...form.meta,
                softDeleted: true,
            },
        }))
    return IDB_rowsWrite(IDB_globalDb, 'forms', forms)
}

// Standard case is that we dont want the deleted forms, main code should not care about this
export async function IDB_formsReadAll() {
    const allForms = await IDB_rowsReadAll<Form_IForm>(IDB_globalDb, 'forms')
    return allForms.filter((form) => !isSoftDelted(form))
}

// For the report upload, where we might need to reference deleted forms
export function IDB_formsReadAllIncDeleted() {
    return IDB_rowsReadAll<Form_IForm>(IDB_globalDb, 'forms')
}

export function IDB_formsWrite(forms: Form_IForm[]) {
    return IDB_rowsWrite(IDB_globalDb, 'forms', forms)
}

export function IDB_formWrite(form: Form_IForm) {
    return IDB_rowWrite(IDB_globalDb, 'forms', form)
}
